import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function KitchenCurrentStatus({ kitchenData }) {
  const isReady = kitchenData?.isReady === true;

  const kitchenExists = kitchenData?.id > 0;

  if (!kitchenExists || !isReady) {
    return null; // Don't render anything if kitchen doesn't exist
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      width: '100%',
      mb: 2
    }}>
      <Box sx={{
        width: '2px',
        height: '20px',
        backgroundColor: '#666',
        marginBottom: '0px'
      }} />

      <Paper
        elevation={2}
        sx={{
          position: 'relative',
          backgroundColor: '#4caf50',
          color: 'white',
          padding: '16px 32px',
          borderRadius: '8px',
          border: '4px solid #fff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3), inset 0 2px 4px rgba(255,255,255,0.2)',
          transform: 'rotate(-2deg)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'rotate(2deg)',
            boxShadow: '0 6px 16px rgba(0,0,0,0.4), inset 0 2px 4px rgba(255,255,255,0.2)'
          }
        }}
      >
        <Typography 
          sx={{ 
            fontSize: '2rem',
            letterSpacing: '4px',
            textAlign: 'center',
            textShadow: '0 0 20px rgba(255,255,255,0.6), 0 2px 4px rgba(0,0,0,0.3)',
            fontFamily: 'Impact, Arial Black, sans-serif'
          }}
        >
          Publicly Visible
        </Typography>

        <Box sx={{
          position: 'absolute',
          top: '8px',
          left: '8px',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: '#ddd',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)'
        }} />
        <Box sx={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: '#ddd',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)'
        }} />
        <Box sx={{
          position: 'absolute',
          bottom: '8px',
          left: '8px',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: '#ddd',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)'
        }} />
        <Box sx={{
          position: 'absolute',
          bottom: '8px',
          right: '8px',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: '#ddd',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)'
        }} />
      </Paper>
    </Box>
  );
}
